const cascaderLocale = {
  pleaseSelect: "请选择"
};
export {
  cascaderLocale
};
//# sourceMappingURL=zh_CN.js.map
